import React, { useState, useEffect } from "react";
import { Row, Col, Dropdown } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import Loader from "../../components/Loader/Loader";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../assets/css/brand.css";
import DeleteWarningMdl from "../../components/common/DeleteWarningMdl";
import { CreateCurrencyApi, deleteCurrencyApi, editCurrencyApi, getCurrency, UpdateCurrencyApi } from "../../../services/apis/EventMangement/CreateEventApi";

const theadData = [
    { heading: "S.No.", sortingVale: "sno" },
    { heading: "Currency Symbol", sortingVale: "currency_symbol" },
    { heading: "Currency Code", sortingVale: "currency_code" },
    { heading: "Currency Name", sortingVale: "currency_name" },
    { heading: "Action", sortingVale: "action" },
];

const PackageCurrency = () => {
    const [sort, setSortata] = useState(10);
    const [loading, setLoading] = useState(false);

    const [currencyList, setCurrencyList] = useState([]);

    const [showDeleteMdl, setShowDeleteMdl] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [tableDataId, setTableDataId] = useState("");


    const [input, setInput] = useState({
        name: "",
        code: "",
        symbol: ""
    });

    const [formErrors, setFormErrors] = useState({});


    const getAllCurrencyList = async () => {
        setLoading(true);
        try {
            const response = await getCurrency();
            setCurrencyList(response?.data?.data);
        } catch (error) {
            console.error("Error fetching cuisines:", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getAllCurrencyList();
    }, []);


    const handleDeleteSubmit = async () => {
        try {
            const res = await deleteCurrencyApi(tableDataId);
            console.log(res.data)
            if (res.status === 200) {
                toast.success(res?.data?.message); // Display success message
                getAllCurrencyList();
                setTableDataId("");
                setShowDeleteMdl(false);
            } else {
                toast.error(
                    res?.data?.message || "Something went wrong. Please try again."
                );
            }
        } catch (err) {
            console.log(err);
        }
    };


    const handleEdit = async (id) => {
        setShowEdit(true);
        setTableDataId(id)
        try {
            const res = await editCurrencyApi(id);
            if (res?.data?.success) {
                setInput(res?.data?.data)
            } else {
                toast.error(
                    res?.data?.message || "Something went wrong. Please try again."
                );
            }
        } catch (err) {
            console.log(err);
        }
    };

    const handleDelete = (id) => {
        setTableDataId(id);
        setShowDeleteMdl(true);
    };




    const handleChange = (e) => {
        const { name, value } = e.target;
        setInput({ ...input, [name]: value });
    };

    const validate = () => {
        let errors = {};
        if (!input.name) errors.name = 'Currency Name is required';
        if (!input.code) errors.code = 'Currency Code is required';
        if (!input.symbol) errors.symbol = 'Currency Symbol is required';

        return errors;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const errors = validate();
        if (Object.keys(errors).length === 0) {
            if (showEdit) {

                try {
                    const response = await UpdateCurrencyApi(tableDataId, input);
                    if (response.data.success) {
                        toast.success(response?.data?.message)

                        getAllCurrencyList();
                        setInput({
                            type: "",
                            description: ""
                        })
                        setShowEdit(false);
                    }


                } catch (error) {
                    toast.error(error?.response?.data?.message)
                }

            } else {
                try {
                    const response = await CreateCurrencyApi(input);

                    if (response?.data?.success) {
                        toast.success(response?.data?.message)
                        getAllCurrencyList();
                        setInput({
                            name: "",
                            code: '',
                            symbol: ""
                        });
                    }

                } catch (error) {
                    toast.error(error?.response?.data?.message)
                }
            }

        } else {
            setFormErrors(errors);
        }
    };

    return (
        <>
            <DeleteWarningMdl title={"table data"} showDeleteMdl={showDeleteMdl} setShowDeleteMdl={setShowDeleteMdl}
                setTableDataId={setTableDataId} handleDeleteSubmit={handleDeleteSubmit} />

            <ToastContainer />

            <Loader visible={loading} />

            <PageTitle
                activeMenu={"Currency"}
                motherMenu={"Home"}
                motherMenuLink={"/dashboard"}
            />

            <Row>
                <Col lg={12}>
                    <div className="card">
                        {/* <div className="card-header">
                            <h4 className="card-title">Add/List Currency</h4>
                            <button className="btn" style={{ padding: "8px", border: "1px solid #6a73fa", color: "#6a73fa" }} ></button>
                        </div> */}
                        <div className="card-body">

                            <form className="mb-4" onSubmit={handleSubmit} >
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label className="form-label">Currency Name</label>
                                            <input
                                                placeholder="Enter Currency Name"
                                                name="name"
                                                type="text"
                                                className="form-control"
                                                value={input.name}
                                                onChange={handleChange}
                                            />
                                            {formErrors.name && <small className="text-danger">{formErrors.name}</small>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label className="form-label">Currency Code</label>
                                            <input
                                                placeholder="Enter Currency Code"
                                                name="code"
                                                type="text"
                                                className="form-control"
                                                value={input.code}
                                                onChange={handleChange}
                                            />
                                            {formErrors.code && <small className="text-danger">{formErrors.code}</small>}
                                        </div>
                                    </div>

                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label className="form-label">Currency Symbol</label>
                                            <input
                                                placeholder="Enter Currency Symbol"
                                                name="symbol"
                                                type="text"
                                                className="form-control"
                                                value={input.symbol}
                                                onChange={handleChange}
                                            />
                                            {formErrors.symbol && <small className="text-danger">{formErrors.symbol}</small>}
                                        </div>
                                    </div>
                                </div>


                                <div className="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-end gap-3">
                                    <button type="button" className="btn btn-primary light" onClick={() => {
                                        setShowEdit(false)
                                        setInput({
                                            name: '',
                                            code: '',
                                            symbol: ''
                                        });
                                    }}>Cancel</button>

                                    <button type="submit" className="btn btn-primary me-1">
                                        {showEdit ? 'Update' : 'Create'}</button>
                                </div>
                            </form>


                            <div className="table-responsive">
                                <div id="holidayList" className="dataTables_wrapper no-footer">
                                    <div className="justify-content-between d-sm-flex">
                                        <div className="dataTables_length">
                                            <label className="d-flex align-items-center">
                                                Show
                                                <Dropdown className="search-drop">
                                                    <Dropdown.Toggle as="div" className="search-drop-btn">
                                                        {sort}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        <Dropdown.Item onClick={() => setSortata("2")}>
                                                            2
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => setSortata("5")}>
                                                            5
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => setSortata("10")}>
                                                            10
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => setSortata("15")}>
                                                            15
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => setSortata("20")}>
                                                            20
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                                entries
                                            </label>
                                        </div>
                                        <div className="dataTables_filter">
                                            <label>
                                                Search :
                                                <input
                                                    type="search"
                                                    className=""
                                                    placeholder=""
                                                />
                                            </label>
                                        </div>
                                    </div>

                                    <table id="example4" className="display dataTable no-footer w-100">
                                        <thead>
                                            <tr>
                                                {theadData?.map((item, ind) => {
                                                    return (
                                                        <th key={ind}>
                                                            {item.heading}
                                                            <span>
                                                                <i
                                                                    className="fa fa-arrow-down ms-2 fs-12"
                                                                    style={{ opacity: "0.7" }}
                                                                />

                                                            </span>
                                                        </th>
                                                    );
                                                })}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currencyList?.map((data, ind) => (
                                                <tr key={ind}>
                                                    <td>
                                                        {ind + 1}
                                                    </td>
                                                    <td className="d-flex align-items-center gap-2">
                                                        {data?.symbol}
                                                    </td>

                                                    <td>
                                                        {data?.code}
                                                    </td>

                                                    <td>
                                                        {data?.name}
                                                    </td>


                                                    <td>
                                                        <button className="btn btn-xs sharp btn-primary me-1"
                                                            onClick={() => handleEdit(data?._id)}
                                                        >
                                                            <i className="fa fa-pencil" />
                                                        </button>

                                                        <button className="btn btn-xs sharp btn-danger"
                                                            onClick={() => handleDelete(data?._id)}
                                                        >
                                                            <i className="fa fa-trash" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default PackageCurrency;
